import React from 'react';
import { PromoBar } from './components/PromoBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Mission } from './components/Mission';
import { ProductDetail } from './components/ProductDetail';
import { FAQ } from './components/FAQ';
import { Legal } from './components/Legal';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-cream" data-id="element-0">
      <PromoBar data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Mission data-id="element-5" />
        <ProductDetail data-id="element-6" />
        <FAQ data-id="element-7" />
        <Legal data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}